import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getAllRoutes, checkRouteConsistency } from '../constants/routes';

const RouteValidator = ({ children }) => {
  const location = useLocation();
  const [routeIssues, setRouteIssues] = useState([]);
  const [isValidRoute, setIsValidRoute] = useState(true);

  useEffect(() => {
    // Validate current route
    const allRoutes = getAllRoutes();
    const currentRoute = allRoutes.find(route => route.path === location.pathname);
    
    if (!currentRoute && location.pathname !== '*') {
      setIsValidRoute(false);
      console.warn(`Route not found in configuration: ${location.pathname}`);
    } else {
      setIsValidRoute(true);
    }

    // Check for route consistency issues
    if (process.env.NODE_ENV === 'development') {
      const issues = checkRouteConsistency();
      setRouteIssues(issues);
      
      if (issues.length > 0) {
        console.group('Route Consistency Issues Found:');
        issues.forEach(issue => {
          console.warn(`${issue.type}: ${issue.message}`, issue);
        });
        console.groupEnd();
      }
    }
  }, [location.pathname]);

  // Development mode route debugging
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      const debugInfo = {
        currentPath: location.pathname,
        validRoute: isValidRoute,
        availableRoutes: getAllRoutes().map(r => ({ path: r.path, component: r.component })),
        routeIssues: routeIssues
      };
      
      console.log('Route Debug Info:', debugInfo);
    }
  }, [location.pathname, isValidRoute, routeIssues]);

  return (
    <>
      {children}
      {/* Development mode route issue indicator */}
      {process.env.NODE_ENV === 'development' && routeIssues.length > 0 && (
        <div 
          className="fixed bottom-4 right-4 bg-warning text-warning-foreground p-3 rounded-lg shadow-lg z-50 max-w-xs"
          style={{ fontSize: '12px' }}
        >
          <div className="font-semibold mb-1">Route Issues Detected:</div>
          <ul className="text-xs space-y-1">
            {routeIssues.slice(0, 3).map((issue, index) => (
              <li key={index}>• {issue.message}</li>
            ))}
            {routeIssues.length > 3 && (
              <li>• And {routeIssues.length - 3} more issues...</li>
            )}
          </ul>
        </div>
      )}
    </>
  );
};

export default RouteValidator;